import { Component, OnInit, Inject } from '@angular/core';
import {MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-add-edit-theme-name',
  templateUrl: './add-edit-theme-name.component.html',
  styleUrls: ['./add-edit-theme-name.component.css']
})
export class AddEditThemeNameComponent {
  theme: any = {};

  constructor(
    public dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.theme = JSON.parse(JSON.stringify(data));
    if (this.theme.name)
      this.theme.name = this.theme.name;
  }


  Save(): void {
    this.dialogRef.close(this.theme);
  }


  Cancel(): void {
    this.dialogRef.close(false);
  }
}
